import { put, call, select } from 'redux-saga/effects'
import { error403, pageIsLoading } from 'domain/loading'
import { transformUser } from 'domain/recruiter/helpers'
import I from 'immutable'
import Api from 'domain/api'
import * as Actions from './actions'
import * as M from 'domain/env'
import * as Router from 'domain/router'

export function* ensureGetRecruiterProfile() {
  yield put({ type: Actions.recruiterProfile.success, payload: I.fromJS({}) })
  yield put({ type: error403, payload: false })
  const headers = yield select(M.userToken)
  if (!headers) return
  yield put({ type: pageIsLoading, payload: true })
  const {
    params: { id }
  } = yield select(Router.matchRoutes)
  try {
    const {
      data: { data }
    } = yield call(Api.getRecruiterProfileR, {
      headers: { Authorization: `Bearer ${headers}` },
      id
    })
    yield put({ type: Actions.recruiterProfile.success, payload: transformUser(I.fromJS(data)) })
  } catch (err) {
    const { statusCode } = err.response.data
    if (statusCode === 403 || statusCode === 404) {
      yield put({ type: error403, payload: true })
    }
    yield put({
      type: Actions.recruiterProfile.failure,
      err
    })
  } finally {
    yield put({ type: pageIsLoading, payload: false })
  }
}
